import { Component, Input } from '@angular/core';
import { PlatformModule } from '@app/platform.module';
import { ColumnFilter } from '../../classes/column-filters/column-filter.abstract';
import { isDateRangeFilter } from '../../classes/column-filters/date-range/date-range-filter.class';
import { ColumnFilterComponent } from './column-filter.component';

/**
 * All the elements in the HTML Template for this component need the class "filter".
 * The parent table component will listen to the events clicked throughout it's entire body, and if the class filter is present on the
 * target of a click event, it will not close all open filer windows.
 *
 * While this may be considered a bit of a hack, it's the simplest and most straightforward way of allowing the kind of actions we want
 * without adding a ton of overhead or complex logic, which would be brittle.
 */

@Component({
    selector: 'app-table-column-filter-popup',
    standalone: true,
    template: `
        @if (filter) {
            <ui-card
                class="popup-wrapper filter visible"
                [class.date-range-filter]="isDateRangeFilter(filter)"
                [withSpacing]="false"
                [withMargin]="false"
            >
                <div class="filter">
                    @if (filter.isReady) {
                        <div class="filter">
                            <app-table-column-filter [filter]="filter" />
                        </div>
                    }
                </div>
            </ui-card>
        }
    `,
    styleUrl: './column-filter-popup.style.scss',
    imports: [ColumnFilterComponent, PlatformModule],
})
export class ColumnFilterPopupComponent {
    @Input() filter?: ColumnFilter = undefined;
    isDateRangeFilter = isDateRangeFilter;
}
